import {Button, Modal} from "react-bootstrap";
import EcheccIcon from "../../../images/suppAcc.svg";
import {useState} from "react";
import {useUpdateTechnician} from "../../../hooks/useUpdateUser";
import {useTranslation} from "react-i18next";

const SuppModal = ({show, setShow}) => {
  const {t} = useTranslation();
  const [inputValue, setInputValue] = useState("");
  const [error, setError] = useState(false);
  const {onRemoveAccount} = useUpdateTechnician();
  const handelButton = () => {
    if (inputValue.trim().toUpperCase() === t("accountDeletionKeyword")) {
      setShow(false);
      onRemoveAccount();
    } else {
      setError(true);
    }
  };
  return (
    <Modal
      className="modal fade"
      show={show}
      onHide={() => {
        setShow(false);
      }}
      centered
    >
      <div className="modal-content">
        <div className="modal-header !border-none">
          <Button
            variant=""
            type="button"
            className="close"
            data-dismiss="modal"
            onClick={() => {
              setShow(false);
            }}
          >
            <span>×</span>
          </Button>
        </div>
        <div className="modal-body !p-2">
          <div className=" flex flex-col gap-2 justify-center items-center sm:!px-12 ">
            <img src={EcheccIcon} alt="ToastIcon" className="w-16 !mb-4" />
            <div className="text-[#FF0000] font-bold text-xl text-center !mb-1">
              {t("deleteAccountConfirmation")}
            </div>

            <div className="text-[#19295C] text-center font-semibold text-sm flex flex-col gap-2">
              <span>{t("deleteConfirmationPart1")}</span>
              <span>{t("deleteAccountRetentionWarning")}</span>
            </div>

            <input
              className=" border p-2 !border-[#E7E7E7] w-full !rounded-md bg-[#F9F9F9]"
              value={inputValue}
              placeholder={t("accountDeletionKeyword")}
              onChange={(e) => setInputValue(e.target.value)}
            />
            {error && (
              <div className="text-[#FF0000] text-xs text-left w-full">
                {t("invalidEntry")}
              </div>
            )}

            <div className="flex gap-4 items-center w-full !mt-4 mb-3 ">
              <button
                onClick={() => {
                  setShow(false);
                }}
                type="button"
                className="!rounded-md w-1/2  bg-white  !py-3 text-[#1A64B9] !border !border-[#1A64B9] font-medium text-sm "
              >
                {t("cancelAction")}
              </button>
              <button
                onClick={handelButton}
                type="button"
                className="!rounded-md w-1/2   !py-3 text-white bg-[#FF0000] font-medium text-sm    "
              >
                {t("confirm")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
export default SuppModal;
